
import { useState,useEffect } from "react";
import marksentryapi from '../api/resultDeclarationRouter';
import loginapi from '../api/login';
import { useNavigate } from "react-router-dom";

import Course from '../components/ResultBatchCard';

function ResultDeclaration({accessToken,setAccessToken,setRefreshFailed,resultEntrySession,setResultEntrySession,sessions}) {
  const navigate = useNavigate();
  const [courses,setCourses]=useState([]);    
  const [isAppLoaded,setIsAppLoaded]=useState(false);
  


    const sessionChanged = async (e) => {
    const session = e.target.value;
    setResultEntrySession(session);

  };


  useEffect(()=>{
    const fetchAT=async ()=>{
      try{      
        setIsAppLoaded(false); 
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/getResultBatches',{session:resultEntrySession},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data));
        setCourses(response.data.allbatches); 
        
      
        setTimeout(() => {
          const mainElement = document.querySelector("main"); // Target <main> directly
          const scrollPosition = sessionStorage.getItem("scrollPosition");
  
          if (mainElement && scrollPosition) {
              mainElement.scrollTo(0, parseInt(scrollPosition, 10)); // Restore scroll position
              //console.log("Restored Scroll Position:", scrollPosition);
          }
      }, 100); // Delay for 100ms to ensure DOM is ready

        //alert(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/getResultBatches',{session:resultEntrySession},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setCourses(response.data.allbatches); 
                        setTimeout(() => {
                          const mainElement = document.querySelector("main"); // Target <main> directly
                          const scrollPosition = sessionStorage.getItem("scrollPosition");
                  
                          if (mainElement && scrollPosition) {
                              mainElement.scrollTo(0, parseInt(scrollPosition, 10)); // Restore scroll position
                              //console.log("Restored Scroll Position:", scrollPosition);
                          }
                      }, 100); // Delay for 100ms to ensure DOM is ready
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[resultEntrySession]);
  
  
  
    return (
      <main>
        <div className="flex flex-col items-center">
          <div className="text-center mb-4">
            <h1 className="text-2xl font-bold text-gray-800 ">RESULT DECLARATION BATCHES</h1>
            <p className="text-center">Select Exam session</p>
            <select
        value={resultEntrySession}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
          </div>
          <div className="flex flex-wrap justify-center gap-4 mt-9">
          {isAppLoaded ? (
            courses.length > 0 ? (
              courses.map((course) => (
                <Course key={course.batch} course={course} session={resultEntrySession} accessToken={accessToken} setAccessToken={setAccessToken} setRefreshFailed={setRefreshFailed} />
              ))
            ) : (
              <p>No batches available.</p>
            )
          ) : (
            <p>Please wait...</p>
          )}
          </div>
        </div>

     
      </main>
    )
  }
  
  export default ResultDeclaration